import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import $tyW6A$react, { useMemo as $tyW6A$useMemo } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
function $c1d7fb2ec91bae71$var$Item(props) {
  return null;
}
$c1d7fb2ec91bae71$var$Item.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var childItems, title, children, rendered, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        childItems = props.childItems, title = props.title, children = props.children;
        rendered = props.title || props.children;
        textValue = props.textValue || (typeof rendered === "string" ? rendered : "") || props["aria-label"] || ""; // suppressTextValueWarning is used in components like Tabs, which don't have type to select support.
        if (!textValue && !(context === null || context === void 0 ? void 0 : context.suppressTextValueWarning)) console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop.");
        _context2.next = 6;
        return {
          type: "item",
          props: props,
          rendered: rendered,
          textValue: textValue,
          "aria-label": props["aria-label"],
          hasChildNodes: $c1d7fb2ec91bae71$var$hasChildItems(props),
          childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
            var _iterator, _step, child, items;
            return _regeneratorRuntime.wrap(function childNodes$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!childItems) {
                    _context.next = 20;
                    break;
                  }
                  _iterator = _createForOfIteratorHelper(childItems);
                  _context.prev = 2;
                  _iterator.s();
                case 4:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 10;
                    break;
                  }
                  child = _step.value;
                  _context.next = 8;
                  return {
                    type: "item",
                    value: child
                  };
                case 8:
                  _context.next = 4;
                  break;
                case 10:
                  _context.next = 15;
                  break;
                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](2);
                  _iterator.e(_context.t0);
                case 15:
                  _context.prev = 15;
                  _iterator.f();
                  return _context.finish(15);
                case 18:
                  _context.next = 24;
                  break;
                case 20:
                  if (!title) {
                    _context.next = 24;
                    break;
                  }
                  items = [];
                  (0, $tyW6A$react).Children.forEach(children, function (child) {
                    items.push({
                      type: "item",
                      element: child
                    });
                  });
                  return _context.delegateYield(items, "t1", 24);
                case 24:
                case "end":
                  return _context.stop();
              }
            }, childNodes, null, [[2, 12, 15, 18]]);
          })
        };
      case 6:
      case "end":
        return _context2.stop();
    }
  }, getCollectionNode);
});
function $c1d7fb2ec91bae71$var$hasChildItems(props) {
  if (props.hasChildItems != null) return props.hasChildItems;
  if (props.childItems) return true;
  if (props.title && (0, $tyW6A$react).Children.count(props.children) > 0) return true;
  return false;
}
// We don't want getCollectionNode to show up in the type definition
var $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 = $c1d7fb2ec91bae71$var$Item;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $9fc4852771d079eb$var$Section(props) {
  return null;
}
$9fc4852771d079eb$var$Section.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var children, title, items;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        children = props.children, title = props.title, items = props.items;
        _context4.next = 3;
        return {
          type: "section",
          props: props,
          hasChildNodes: true,
          rendered: title,
          "aria-label": props["aria-label"],
          childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
            var _iterator2, _step2, item, _items;
            return _regeneratorRuntime.wrap(function childNodes$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(typeof children === "function")) {
                    _context3.next = 22;
                    break;
                  }
                  if (items) {
                    _context3.next = 3;
                    break;
                  }
                  throw new Error("props.children was a function but props.items is missing");
                case 3:
                  _iterator2 = _createForOfIteratorHelper(items);
                  _context3.prev = 4;
                  _iterator2.s();
                case 6:
                  if ((_step2 = _iterator2.n()).done) {
                    _context3.next = 12;
                    break;
                  }
                  item = _step2.value;
                  _context3.next = 10;
                  return {
                    type: "item",
                    value: item,
                    renderer: children
                  };
                case 10:
                  _context3.next = 6;
                  break;
                case 12:
                  _context3.next = 17;
                  break;
                case 14:
                  _context3.prev = 14;
                  _context3.t0 = _context3["catch"](4);
                  _iterator2.e(_context3.t0);
                case 17:
                  _context3.prev = 17;
                  _iterator2.f();
                  return _context3.finish(17);
                case 20:
                  _context3.next = 25;
                  break;
                case 22:
                  _items = [];
                  (0, $tyW6A$react).Children.forEach(children, function (child) {
                    _items.push({
                      type: "item",
                      element: child
                    });
                  });
                  return _context3.delegateYield(_items, "t1", 25);
                case 25:
                case "end":
                  return _context3.stop();
              }
            }, childNodes, null, [[4, 14, 17, 20]]);
          })
        };
      case 3:
      case "end":
        return _context4.stop();
    }
  }, getCollectionNode);
});
// We don't want getCollectionNode to show up in the type definition
var $9fc4852771d079eb$export$6e2c8f0811a474ce = $9fc4852771d079eb$var$Section;

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
var $eb2240fc39a57fa5$export$bf788dd355e3a401 = /*#__PURE__*/function () {
  function $eb2240fc39a57fa5$export$bf788dd355e3a401() {
    _classCallCheck(this, $eb2240fc39a57fa5$export$bf788dd355e3a401);
    this.cache = new WeakMap();
  }
  _createClass($eb2240fc39a57fa5$export$bf788dd355e3a401, [{
    key: "build",
    value: function build(props, context) {
      var _this = this;
      this.context = context;
      return $eb2240fc39a57fa5$var$iterable(function () {
        return _this.iterateCollection(props);
      });
    }
  }, {
    key: "iterateCollection",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function iterateCollection(props) {
      var children, items, _iterator3, _step3, item, _items2, index, _i, _items3, _item, nodes, _iterator4, _step4, node;
      return _regeneratorRuntime.wrap(function iterateCollection$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            children = props.children, items = props.items;
            if (!(typeof children === "function")) {
              _context5.next = 22;
              break;
            }
            if (items) {
              _context5.next = 4;
              break;
            }
            throw new Error("props.children was a function but props.items is missing");
          case 4:
            _iterator3 = _createForOfIteratorHelper(props.items);
            _context5.prev = 5;
            _iterator3.s();
          case 7:
            if ((_step3 = _iterator3.n()).done) {
              _context5.next = 12;
              break;
            }
            item = _step3.value;
            return _context5.delegateYield(this.getFullNode({
              value: item
            }, {
              renderer: children
            }), "t0", 10);
          case 10:
            _context5.next = 7;
            break;
          case 12:
            _context5.next = 17;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t1 = _context5["catch"](5);
            _iterator3.e(_context5.t1);
          case 17:
            _context5.prev = 17;
            _iterator3.f();
            return _context5.finish(17);
          case 20:
            _context5.next = 50;
            break;
          case 22:
            _items2 = [];
            (0, $tyW6A$react).Children.forEach(children, function (child) {
              _items2.push(child);
            });
            index = 0;
            _i = 0, _items3 = _items2;
          case 26:
            if (!(_i < _items3.length)) {
              _context5.next = 50;
              break;
            }
            _item = _items3[_i];
            nodes = this.getFullNode({
              element: _item,
              index: index
            }, {});
            _iterator4 = _createForOfIteratorHelper(nodes);
            _context5.prev = 30;
            _iterator4.s();
          case 32:
            if ((_step4 = _iterator4.n()).done) {
              _context5.next = 39;
              break;
            }
            node = _step4.value;
            index++;
            _context5.next = 37;
            return node;
          case 37:
            _context5.next = 32;
            break;
          case 39:
            _context5.next = 44;
            break;
          case 41:
            _context5.prev = 41;
            _context5.t2 = _context5["catch"](30);
            _iterator4.e(_context5.t2);
          case 44:
            _context5.prev = 44;
            _iterator4.f();
            return _context5.finish(44);
          case 47:
            _i++;
            _context5.next = 26;
            break;
          case 50:
          case "end":
            return _context5.stop();
        }
      }, iterateCollection, this, [[5, 14, 17, 20], [30, 41, 44, 47]]);
    })
  }, {
    key: "getKey",
    value: function getKey(item, partialNode, state, parentKey) {
      if (item.key != null) return item.key;
      if (partialNode.type === "cell" && partialNode.key != null) return "".concat(parentKey).concat(partialNode.key);
      var v = partialNode.value;
      if (v != null) {
        var _v_key;
        var key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
        if (key == null) throw new Error("No key found for item");
        return key;
      }
      return parentKey ? "".concat(parentKey, ".").concat(partialNode.index) : "$.".concat(partialNode.index);
    }
  }, {
    key: "getChildState",
    value: function getChildState(state, partialNode) {
      return {
        renderer: partialNode.renderer || state.renderer
      };
    }
  }, {
    key: "getFullNode",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function getFullNode(partialNode, state, parentKey, parentNode) {
      var element, cached, type, name, _childNodes, index, result, childNode, nodeKey, nodes, children, _iterator5, _step5, _node, builder, node;
      return _regeneratorRuntime.wrap(function getFullNode$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            // If there's a value instead of an element on the node, and a parent renderer function is available,
            // use it to render an element for the value.
            element = partialNode.element;
            if (!(!element && partialNode.value && state && state.renderer)) {
              _context7.next = 10;
              break;
            }
            cached = this.cache.get(partialNode.value);
            if (!(cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context)))) {
              _context7.next = 9;
              break;
            }
            cached.index = partialNode.index;
            cached.parentKey = parentNode ? parentNode.key : null;
            _context7.next = 8;
            return cached;
          case 8:
            return _context7.abrupt("return");
          case 9:
            element = state.renderer(partialNode.value);
          case 10:
            if (!(0, $tyW6A$react).isValidElement(element)) {
              _context7.next = 51;
              break;
            }
            type = element.type;
            if (!(typeof type !== "function" && typeof type.getCollectionNode !== "function")) {
              _context7.next = 15;
              break;
            }
            name = typeof element.type === "function" ? element.type.name : element.type;
            throw new Error("Unknown element <".concat(name, "> in collection."));
          case 15:
            _childNodes = type.getCollectionNode(element.props, this.context);
            index = partialNode.index;
            result = _childNodes.next();
          case 18:
            if (!(!result.done && result.value)) {
              _context7.next = 50;
              break;
            }
            childNode = result.value;
            partialNode.index = index;
            nodeKey = childNode.key;
            if (!nodeKey) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
            nodes = this.getFullNode(_objectSpread(_objectSpread({}, childNode), {}, {
              key: nodeKey,
              index: index,
              wrapper: $eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
            }), this.getChildState(state, childNode), parentKey ? "".concat(parentKey).concat(element.key) : element.key, parentNode);
            children = _toConsumableArray(nodes);
            _iterator5 = _createForOfIteratorHelper(children);
            _context7.prev = 26;
            _iterator5.s();
          case 28:
            if ((_step5 = _iterator5.n()).done) {
              _context7.next = 39;
              break;
            }
            _node = _step5.value;
            // Cache the node based on its value
            _node.value = childNode.value || partialNode.value;
            if (_node.value) this.cache.set(_node.value, _node);
            // The partial node may have specified a type for the child in order to specify a constraint.
            // Verify that the full node that was built recursively matches this type.
            if (!(partialNode.type && _node.type !== partialNode.type)) {
              _context7.next = 34;
              break;
            }
            throw new Error("Unsupported type <".concat($eb2240fc39a57fa5$var$capitalize(_node.type), "> in <").concat($eb2240fc39a57fa5$var$capitalize(parentNode.type), ">. Only <").concat($eb2240fc39a57fa5$var$capitalize(partialNode.type), "> is supported."));
          case 34:
            index++;
            _context7.next = 37;
            return _node;
          case 37:
            _context7.next = 28;
            break;
          case 39:
            _context7.next = 44;
            break;
          case 41:
            _context7.prev = 41;
            _context7.t0 = _context7["catch"](26);
            _iterator5.e(_context7.t0);
          case 44:
            _context7.prev = 44;
            _iterator5.f();
            return _context7.finish(44);
          case 47:
            result = _childNodes.next(children);
            _context7.next = 18;
            break;
          case 50:
            return _context7.abrupt("return");
          case 51:
            if (!(partialNode.key == null)) {
              _context7.next = 53;
              break;
            }
            return _context7.abrupt("return");
          case 53:
            // Create full node
            builder = this;
            node = {
              type: partialNode.type,
              props: partialNode.props,
              key: partialNode.key,
              parentKey: parentNode ? parentNode.key : null,
              value: partialNode.value,
              level: parentNode ? parentNode.level + 1 : 0,
              index: partialNode.index,
              rendered: partialNode.rendered,
              textValue: partialNode.textValue,
              "aria-label": partialNode["aria-label"],
              wrapper: partialNode.wrapper,
              shouldInvalidate: partialNode.shouldInvalidate,
              hasChildNodes: partialNode.hasChildNodes,
              childNodes: $eb2240fc39a57fa5$var$iterable( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var index, _iterator6, _step6, child, _nodes, _iterator7, _step7, _node2;
                return _regeneratorRuntime.wrap(function _callee$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      if (partialNode.hasChildNodes) {
                        _context6.next = 2;
                        break;
                      }
                      return _context6.abrupt("return");
                    case 2:
                      index = 0;
                      _iterator6 = _createForOfIteratorHelper(partialNode.childNodes());
                      _context6.prev = 4;
                      _iterator6.s();
                    case 6:
                      if ((_step6 = _iterator6.n()).done) {
                        _context6.next = 31;
                        break;
                      }
                      child = _step6.value;
                      // Ensure child keys are globally unique by prepending the parent node's key
                      if (child.key != null)
                        // TODO: Remove this line entirely and enforce that users always provide unique keys.
                        // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                        // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                        // children having a key of `abc`.
                        child.key = "".concat(node.key).concat(child.key);
                      child.index = index;
                      _nodes = builder.getFullNode(child, builder.getChildState(state, child), node.key, node);
                      _iterator7 = _createForOfIteratorHelper(_nodes);
                      _context6.prev = 12;
                      _iterator7.s();
                    case 14:
                      if ((_step7 = _iterator7.n()).done) {
                        _context6.next = 21;
                        break;
                      }
                      _node2 = _step7.value;
                      index++;
                      _context6.next = 19;
                      return _node2;
                    case 19:
                      _context6.next = 14;
                      break;
                    case 21:
                      _context6.next = 26;
                      break;
                    case 23:
                      _context6.prev = 23;
                      _context6.t0 = _context6["catch"](12);
                      _iterator7.e(_context6.t0);
                    case 26:
                      _context6.prev = 26;
                      _iterator7.f();
                      return _context6.finish(26);
                    case 29:
                      _context6.next = 6;
                      break;
                    case 31:
                      _context6.next = 36;
                      break;
                    case 33:
                      _context6.prev = 33;
                      _context6.t1 = _context6["catch"](4);
                      _iterator6.e(_context6.t1);
                    case 36:
                      _context6.prev = 36;
                      _iterator6.f();
                      return _context6.finish(36);
                    case 39:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee, null, [[4, 33, 36, 39], [12, 23, 26, 29]]);
              }))
            };
            _context7.next = 57;
            return node;
          case 57:
          case "end":
            return _context7.stop();
        }
      }, getFullNode, this, [[26, 41, 44, 47]]);
    })
  }]);
  return $eb2240fc39a57fa5$export$bf788dd355e3a401;
}(); // Wraps an iterator function as an iterable object, and caches the results.
function $eb2240fc39a57fa5$var$iterable(iterator) {
  var cache = [];
  var iterable = null;
  return _defineProperty({}, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _i2, _cache, item, _iterator8, _step8, _item2;
    return _regeneratorRuntime.wrap(function _callee2$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _i2 = 0, _cache = cache;
        case 1:
          if (!(_i2 < _cache.length)) {
            _context8.next = 8;
            break;
          }
          item = _cache[_i2];
          _context8.next = 5;
          return item;
        case 5:
          _i2++;
          _context8.next = 1;
          break;
        case 8:
          if (!iterable) iterable = iterator();
          _iterator8 = _createForOfIteratorHelper(iterable);
          _context8.prev = 10;
          _iterator8.s();
        case 12:
          if ((_step8 = _iterator8.n()).done) {
            _context8.next = 19;
            break;
          }
          _item2 = _step8.value;
          cache.push(_item2);
          _context8.next = 17;
          return _item2;
        case 17:
          _context8.next = 12;
          break;
        case 19:
          _context8.next = 24;
          break;
        case 21:
          _context8.prev = 21;
          _context8.t0 = _context8["catch"](10);
          _iterator8.e(_context8.t0);
        case 24:
          _context8.prev = 24;
          _iterator8.f();
          return _context8.finish(24);
        case 27:
        case "end":
          return _context8.stop();
      }
    }, _callee2, null, [[10, 21, 24, 27]]);
  }));
}
function $eb2240fc39a57fa5$var$compose(outer, inner) {
  if (outer && inner) return function (element) {
    return outer(inner(element));
  };
  if (outer) return outer;
  if (inner) return inner;
}
function $eb2240fc39a57fa5$var$capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}
function $7613b1592d41b092$export$6cd28814d92fa9c9(props, factory, context) {
  var builder = (0, $tyW6A$useMemo)(function () {
    return new (0, $eb2240fc39a57fa5$export$bf788dd355e3a401)();
  }, []);
  var children = props.children,
    items = props.items,
    collection = props.collection;
  var result = (0, $tyW6A$useMemo)(function () {
    if (collection) return collection;
    var nodes = builder.build({
      children: children,
      items: items
    }, context);
    return factory(nodes);
  }, [builder, children, items, collection, context, factory]);
  return result;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
function $c5a24bc478652b5f$export$1005530eda016c13(node, collection) {
  // New API: call collection.getChildren with the node key.
  if (typeof collection.getChildren === "function") return collection.getChildren(node.key);
  // Old API: access childNodes directly.
  return node.childNodes;
}
function $c5a24bc478652b5f$export$fbdeaa6a76694f71(iterable) {
  return $c5a24bc478652b5f$export$5f3398f8733f90e2(iterable, 0);
}
function $c5a24bc478652b5f$export$5f3398f8733f90e2(iterable, index) {
  if (index < 0) return undefined;
  var i = 0;
  var _iterator9 = _createForOfIteratorHelper(iterable),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var item = _step9.value;
      if (i === index) return item;
      i++;
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
}
function $c5a24bc478652b5f$export$7475b2c64539e4cf(iterable) {
  var lastItem = undefined;
  var _iterator10 = _createForOfIteratorHelper(iterable),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var value = _step10.value;
      lastItem = value;
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  return lastItem;
}
function $c5a24bc478652b5f$export$8c434b3a7a4dad6(collection, a, b) {
  // If the two nodes have the same parent, compare their indices.
  if (a.parentKey === b.parentKey) return a.index - b.index;
  // Otherwise, collect all of the ancestors from each node, and find the first one that doesn't match starting from the root.
  // Include the base nodes in case we are comparing nodes of different levels so that we can compare the higher node to the lower level node's
  // ancestor of the same level
  var aAncestors = [].concat(_toConsumableArray($c5a24bc478652b5f$var$getAncestors(collection, a)), [a]);
  var bAncestors = [].concat(_toConsumableArray($c5a24bc478652b5f$var$getAncestors(collection, b)), [b]);
  var firstNonMatchingAncestor = aAncestors.slice(0, bAncestors.length).findIndex(function (a, i) {
    return a !== bAncestors[i];
  });
  if (firstNonMatchingAncestor !== -1) {
    // Compare the indices of two children within the common ancestor.
    a = aAncestors[firstNonMatchingAncestor];
    b = bAncestors[firstNonMatchingAncestor];
    return a.index - b.index;
  }
  // If there isn't a non matching ancestor, we might be in a case where one of the nodes is the ancestor of the other.
  if (aAncestors.findIndex(function (node) {
    return node === b;
  }) >= 0) return 1;else if (bAncestors.findIndex(function (node) {
    return node === a;
  }) >= 0) return -1;
  // 🤷
  return -1;
}
function $c5a24bc478652b5f$var$getAncestors(collection, node) {
  var parents = [];
  while ((node === null || node === void 0 ? void 0 : node.parentKey) != null) {
    node = collection.getItem(node.parentKey);
    parents.unshift(node);
  }
  return parents;
}
var $453cc9f0df89c0a5$var$cache = new WeakMap();
function $453cc9f0df89c0a5$export$77d5aafae4e095b2(collection) {
  var count = $453cc9f0df89c0a5$var$cache.get(collection);
  if (count != null) return count;
  count = 0;
  var countItems = function countItems(items) {
    var _iterator11 = _createForOfIteratorHelper(items),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var item = _step11.value;
        if (item.type === "section") countItems((0, $c5a24bc478652b5f$export$1005530eda016c13)(item, collection));else count++;
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  };
  countItems(collection);
  $453cc9f0df89c0a5$var$cache.set(collection, count);
  return count;
}
export { $c1d7fb2ec91bae71$export$6d08773d2e66f8f2 as Item, $9fc4852771d079eb$export$6e2c8f0811a474ce as Section, $7613b1592d41b092$export$6cd28814d92fa9c9 as useCollection, $453cc9f0df89c0a5$export$77d5aafae4e095b2 as getItemCount, $c5a24bc478652b5f$export$1005530eda016c13 as getChildNodes, $c5a24bc478652b5f$export$fbdeaa6a76694f71 as getFirstItem, $c5a24bc478652b5f$export$7475b2c64539e4cf as getLastItem, $c5a24bc478652b5f$export$5f3398f8733f90e2 as getNthItem, $c5a24bc478652b5f$export$8c434b3a7a4dad6 as compareNodeOrder, $eb2240fc39a57fa5$export$bf788dd355e3a401 as CollectionBuilder };